import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { WizardStepId } from "../../helpers/wizardSteps";

interface InitialState {
  sidebarCollapsed: boolean;
  header: {
    title: string;
    navigations: { title: string; url?: string }[];
    /** The title is user text (a stream name): Rubik 700 with an ellipsis, never Dela. */
    userContent: boolean;
  };
  wizardStepByStream: Record<string, WizardStepId | null>;
}

const initialState: InitialState = {
  sidebarCollapsed: false,
  header: {
    title: "",
    navigations: [],
    userContent: false,
  },
  wizardStepByStream: {},
};

export const LayoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setSidebarCollapsed(state, action: PayloadAction<boolean>) {
      state.sidebarCollapsed = action.payload;
    },
    setHeader(state, action: PayloadAction<InitialState["header"]>) {
      state.header = action.payload;
    },
    setWizardStep(
      state,
      action: PayloadAction<{ streamId: string; step: WizardStepId | null }>,
    ) {
      state.wizardStepByStream[action.payload.streamId] = action.payload.step;
    },
  },
});

export const {
  setSidebarCollapsed,
  setHeader,
  setWizardStep,
} = LayoutSlice.actions;
